<div class="space-y-5">
  <div
    *ngFor="let section of sections"
    class="rounded-3xl border border-gray-200/80 bg-white/40 p-4 shadow-sm dark:border-[#191e3a] dark:bg-dark/10 md:p-6"
  >
    <h3 class="mb-4 text-base font-semibold text-gray-900 dark:text-white">{{ section.title }}</h3>
    <div class="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
      <label *ngFor="let f of section.fields" class="flex flex-col gap-1.5 text-sm">
        <span class="flex items-center gap-2 font-medium text-gray-900 dark:text-white">
          {{ f.label }}
          <span *ngIf="isLocked(f.path)" class="rounded bg-amber-100 px-1.5 text-[11px] font-medium text-amber-700 dark:bg-amber-900/30 dark:text-amber-300">locked min</span>
        </span>

        <ng-container [ngSwitch]="ctrl(f.path).type">
          <input
            *ngSwitchCase="'number'"
            type="number"
            class="form-input w-full rounded-xl border-gray-200 bg-white dark:border-[#191e3a] dark:bg-[#0e1726]"
            [ngModel]="value(f.path)"
            (ngModelChange)="set(f.path, $event === null ? null : +$event)"
            [name]="f.path"
            [min]="$any(ctrl(f.path)).min"
            [max]="$any(ctrl(f.path)).max"
            [step]="$any(ctrl(f.path)).step"
          />
          <input
            *ngSwitchCase="'text'"
            type="text"
            class="form-input w-full rounded-xl border-gray-200 bg-white dark:border-[#191e3a] dark:bg-[#0e1726]"
            [ngModel]="value(f.path)"
            (ngModelChange)="set(f.path, $event)"
            [name]="f.path"
          />
          <label *ngSwitchCase="'boolean'" class="relative inline-flex h-6 w-11 cursor-pointer items-center">
            <input
              type="checkbox"
              class="peer sr-only"
              [ngModel]="value(f.path)"
              (ngModelChange)="set(f.path, $event)"
              [name]="f.path"
            />
            <span class="h-6 w-11 rounded-full bg-gray-200 transition peer-checked:bg-[#303030] dark:bg-white/10"></span>
            <span class="absolute left-0.5 h-5 w-5 rounded-full bg-white shadow transition peer-checked:translate-x-5"></span>
          </label>
          <select
            *ngSwitchCase="'enum'"
            class="form-select w-full rounded-xl border-gray-200 bg-white dark:border-[#191e3a] dark:bg-[#0e1726]"
            [ngModel]="value(f.path)"
            (ngModelChange)="set(f.path, $event)"
            [name]="f.path"
          >
            <option *ngFor="let o of $any(ctrl(f.path)).options" [value]="o">{{ o }}</option>
          </select>
        </ng-container>

        <span *ngIf="f.hint" class="text-[11px] leading-tight text-gray-500 dark:text-gray-400">{{ f.hint }}</span>
      </label>
    </div>

    <p
      *ngIf="section.key === 'scoring'"
      class="mt-3 text-xs font-medium"
      [class.text-red-600]="weightTotal !== 100"
      [class.text-gray-500]="weightTotal === 100"
    >
      Weights total: {{ weightTotal }} / 100
    </p>
  </div>

  <div class="flex flex-wrap gap-3">
    <button
      type="button"
      class="btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-6 py-2.5 text-sm font-medium text-black shadow-none hover:bg-gray-50 disabled:opacity-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5"
      [disabled]="busy"
      (click)="onValidate()"
    >
      Validate
    </button>
    <button
      *ngIf="showPublish"
      type="button"
      class="btn rounded-full bg-[#303030] px-6 py-2.5 text-sm font-semibold text-white hover:bg-black disabled:opacity-50 dark:bg-gray-900 dark:hover:bg-black"
      [disabled]="busy"
      (click)="onSavePublish()"
    >
      Save &amp; publish
    </button>
    <button
      type="button"
      class="btn rounded-full px-6 py-2.5 text-sm font-medium disabled:opacity-50"
      [ngClass]="showPublish
        ? 'border border-gray-300 bg-white text-black hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white dark:hover:bg-white/5'
        : 'bg-[#303030] font-semibold text-white hover:bg-black dark:bg-gray-900 dark:hover:bg-black'"
      [disabled]="busy"
      (click)="onSave()"
    >
      Save as draft
    </button>
  </div>
</div>
